<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <div style="display:flex; justify-content:space-between; align-items:center;">
                            <h3 class="card-title">Tiketi ({{ totalRecords }})</h3>
                            <base-button type="success" @click="openCreate()">
                                <i class="tim-icons icon-simple-add"></i> Novi tiket
                            </base-button>
                        </div>
                    </template>

                    <div class="row">
                        <div class="col-md-3">
                            <h4 class="card-title">Status</h4>
                            <base-input>
                                <el-select v-model="filter.status" class="select-primary" clearable
                                    @clear="filter.status = null">
                                    <el-option v-for="s in statuses" class="select-primary" :label="s.name"
                                        :value="s.id" :key="s.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 class="card-title">Prioritet</h4>
                            <base-input>
                                <el-select v-model="filter.priority" class="select-primary" clearable
                                    @clear="filter.priority = null">
                                    <el-option v-for="p in priorities" class="select-primary" :label="p.name"
                                        :value="p.id" :key="p.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 class="card-title">Kategorija</h4>
                            <base-input>
                                <el-select v-model="filter.category" class="select-primary" clearable
                                    @clear="filter.category = null">
                                    <el-option v-for="cg in categories" class="select-primary" :label="cg.name"
                                        :value="cg.id" :key="cg.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 class="card-title">Pretraga</h4>
                            <base-input type="text" v-model="filter.search" placeholder="Naslov"></base-input>
                        </div>
                        <div class="col-md-2">
                            <h4 class="card-title"> </h4>
                            <base-button class="mt-3" type="primary" @click="page = 1; getTickets()">Pretraži</base-button>
                        </div>
                    </div>

                    <el-table :data="tickets">
                        <el-table-column min-width="120" label="Datum">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="180" prop="title" label="Naslov">
                            <template slot-scope="scope">
                                <span>{{ scope.row.title }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90" label="Kategorija">
                            <template slot-scope="scope">
                                <span>{{ scope.row.categoryName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90" label="Prioritet">
                            <template slot-scope="scope">
                                <span :style="{ color: priorityColor(scope.row.priority) }">{{ scope.row.priorityName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" label="Status">
                            <template slot-scope="scope">
                                <span :style="{ color: statusColor(scope.row.status) }">{{ scope.row.statusName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="70" label="Poruke">
                            <template slot-scope="scope">
                                <span>{{ scope.row.messageCount }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="110" label="Autor">
                            <template slot-scope="scope">
                                <span>{{ scope.row.userName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90" header-align="right" align="right" label="Akcije">
                            <div slot-scope="scope" class="text-right table-actions">
                                <base-button type="info" class="btn-link" @click="openTicket(scope.row)">Otvori</base-button>
                            </div>
                        </el-table-column>
                    </el-table>

                    <div class="block">
                        <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPages }}</span><br>
                        <base-pagination class="pagination-no-border" v-model="page" :per-page="max"
                            :total="totalRecords" @input="changeP">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <!-- KREIRANJE / IZMENA -->
        <modal :show.sync="createModal" :show-close="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="createModal = false">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card>
                <h4 slot="header" class="card-title">{{ form.id ? 'Izmena tiketa' : 'Novi tiket' }}</h4>
                <base-input label="Naslov" type="text" v-model="form.title" placeholder="Kratak naslov problema"></base-input>
                <div class="row">
                    <div class="col-md-6">
                        <label class="control-label">Kategorija</label>
                        <base-input>
                            <el-select v-model="form.category" class="select-primary" style="width:100%">
                                <el-option v-for="cg in categories" :label="cg.name" :value="cg.id" :key="cg.id"></el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <div class="col-md-6">
                        <label class="control-label">Prioritet</label>
                        <base-input>
                            <el-select v-model="form.priority" class="select-primary" style="width:100%">
                                <el-option v-for="p in priorities" :label="p.name" :value="p.id" :key="p.id"></el-option>
                            </el-select>
                        </base-input>
                    </div>
                </div>
                <label class="control-label">Opis</label>
                <textarea class="form-control ticket-textarea" v-model="form.description"
                    placeholder="Detaljan opis..."></textarea>
                <base-button type="success" class="mt-3" @click="saveTicket()">Sačuvaj</base-button>
            </card>
        </modal>

        <!-- DETALJ + THREAD -->
        <modal :show.sync="detailModal" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="detailModal = false">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card v-if="ticket.id">
                <h4 slot="header" class="card-title">{{ ticket.title }}</h4>
                <p style="color:#ccc;">
                    <span :style="{ color: statusColor(ticket.status) }">{{ ticket.statusName }}</span> &nbsp;|&nbsp;
                    <span :style="{ color: priorityColor(ticket.priority) }">{{ ticket.priorityName }}</span> &nbsp;|&nbsp;
                    {{ ticket.categoryName }} &nbsp;|&nbsp;
                    {{ ticket.userName }} &nbsp;|&nbsp;
                    {{ (new Date(ticket.stampLong)).toLocaleString("de-DE") }}
                </p>
                <div class="ticket-desc">{{ ticket.description }}</div>

                <!-- Promena statusa -->
                <div class="row" style="margin-top:15px;">
                    <div class="col-md-6">
                        <label class="control-label">Promeni status</label>
                        <base-input>
                            <el-select v-model="newStatus" class="select-primary" style="width:100%">
                                <el-option v-for="s in statuses" :label="s.name" :value="s.id" :key="s.id"></el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <div class="col-md-6">
                        <label class="control-label">&nbsp;</label><br>
                        <base-button type="primary" @click="changeStatus()">Sačuvaj status</base-button>
                    </div>
                </div>

                <hr style="border-color: rgba(255,255,255,0.2);">
                <h5 style="color:#fff;">Odgovori</h5>

                <div class="ticket-thread">
                    <div v-for="m in messages" :key="m.id" class="ticket-msg">
                        <div class="ticket-msg-head">
                            <strong>{{ m.userName }}</strong>
                            <span class="ticket-msg-time">{{ (new Date(m.stampLong)).toLocaleString("de-DE") }}</span>
                        </div>
                        <div class="ticket-msg-body">{{ m.message }}</div>
                    </div>
                    <div v-if="messages.length === 0" style="color:#888;">Još nema odgovora.</div>
                </div>

                <label class="control-label mt-3">Novi odgovor</label>
                <textarea class="form-control ticket-textarea-sm" v-model="replyText" placeholder="Napiši odgovor..."></textarea>
                <base-button type="success" class="mt-2" @click="addMessage()">Pošalji</base-button>
            </card>
        </modal>
    </div>
</template>
<script>
import { TabPane, Tabs, BasePagination } from 'src/components';
import { Table, TableColumn, Select, Option } from 'element-ui';
import axios from '@/util/axiosinstance'
import swal from 'sweetalert2';
import { Modal } from '@/components';

const statuses = [
    { id: 0, name: 'Otvoren' },
    { id: 1, name: 'U toku' },
    { id: 2, name: 'Čeka odgovor' },
    { id: 3, name: 'Zatvoren' }
]
const priorities = [
    { id: 0, name: 'Nizak' },
    { id: 1, name: 'Srednji' },
    { id: 2, name: 'Visok' }
]
const categories = [
    { id: 0, name: 'Kvar' },
    { id: 1, name: 'Pitanje' },
    { id: 2, name: 'Zahtev' }
]

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        BasePagination,
        TabPane,
        Tabs,
        Modal
    },
    mounted() {
        this.getTickets()
    },
    data() {
        return {
            statuses,
            priorities,
            categories,
            url: 'https://budva.scancar.org:8443/kuca',
            loading: false,
            tickets: [],
            filter: {
                status: null,
                priority: null,
                category: null,
                search: null
            },
            page: 1,
            max: 10,
            totalRecords: 0,
            totalPages: 0,
            createModal: false,
            form: {
                id: null,
                title: '',
                description: '',
                category: 0,
                priority: 1
            },
            detailModal: false,
            ticket: {},
            messages: [],
            newStatus: 0,
            replyText: ''
        };
    },
    methods: {
        statusColor(s) {
            return ['#1d8cf8', '#ff8d72', '#ba54f5', '#00f2c3'][s] || '#fff';
        },
        priorityColor(p) {
            return ['#888', '#ff8d72', '#fd5d93'][p] || '#fff';
        },
        changeP(item) {
            this.page = item
            this.getTickets()
        },
        getTickets() {
            this.loading = true
            const f = Object.assign({}, this.filter)
            f.page = this.page
            f.max = this.max
            axios.post(this.url + '/supportTicket/getTickets', f).then(result => {
                this.loading = false
                if (result.data.result === 'ok') {
                    this.tickets = result.data.tickets
                    this.totalRecords = result.data.totalRecords
                    this.totalPages = result.data.totalPages
                } else {
                    this.notifyErr(result.data.reason)
                }
            }).catch(() => { this.loading = false })
        },
        openCreate() {
            this.form = { id: null, title: '', description: '', category: 0, priority: 1 }
            this.createModal = true
        },
        saveTicket() {
            if (!this.form.title || !this.form.title.trim()) {
                this.notifyWarn('Unesite naslov')
                return
            }
            this.loading = true
            axios.post(this.url + '/supportTicket/saveTicket', this.form).then(result => {
                this.loading = false
                if (result.data.result === 'ok') {
                    this.notifyOk('Tiket sačuvan')
                    this.createModal = false
                    this.getTickets()
                } else {
                    this.notifyErr(result.data.reason)
                }
            }).catch(() => { this.loading = false })
        },
        openTicket(row) {
            this.loadTicket(row.id)
        },
        loadTicket(id) {
            this.loading = true
            axios.get(this.url + '/supportTicket/getTicket?id=' + id).then(result => {
                this.loading = false
                if (result.data.result === 'ok') {
                    this.ticket = result.data.ticket
                    this.messages = result.data.ticket.messages || []
                    this.newStatus = result.data.ticket.status
                    this.replyText = ''
                    this.detailModal = true
                } else {
                    this.notifyErr(result.data.reason)
                }
            }).catch(() => { this.loading = false })
        },
        addMessage() {
            if (!this.replyText || !this.replyText.trim()) {
                this.notifyWarn('Poruka je prazna')
                return
            }
            this.loading = true
            axios.post(this.url + '/supportTicket/addMessage', { ticketId: this.ticket.id, message: this.replyText }).then(result => {
                this.loading = false
                if (result.data.result === 'ok') {
                    this.replyText = ''
                    this.loadTicket(this.ticket.id)
                    this.getTickets()
                } else {
                    this.notifyErr(result.data.reason)
                }
            }).catch(() => { this.loading = false })
        },
        changeStatus() {
            this.loading = true
            axios.post(this.url + '/supportTicket/changeStatus', { ticketId: this.ticket.id, status: this.newStatus }).then(result => {
                this.loading = false
                if (result.data.result === 'ok') {
                    this.notifyOk('Status promenjen')
                    this.loadTicket(this.ticket.id)
                    this.getTickets()
                } else {
                    this.notifyErr(result.data.reason)
                }
            }).catch(() => { this.loading = false })
        },
        notifyOk(msg) {
            this.$notify({ message: msg, timeout: 3000, icon: 'tim-icons icon-check-2', horizontalAlign: "right", verticalAlign: "top", type: 'success' });
        },
        notifyErr(msg) {
            this.$notify({ message: msg || 'Greška', timeout: 3000, icon: 'tim-icons icon-bell-55', horizontalAlign: "right", verticalAlign: "top", type: 'danger' });
        },
        notifyWarn(msg) {
            this.$notify({ message: msg, timeout: 3000, icon: 'tim-icons icon-bell-55', horizontalAlign: "right", verticalAlign: "top", type: 'warning' });
        }
    }
};
</script>
<style lang="scss">
.custom-modal { background-color: rgba(0, 0, 0, 0.8); }
.custom-modal-content { background-color: #27293d; color: #fff; border-radius: 8px; max-width: 760px; width: 760px; }
.custom-modal-body { padding: 20px; }

.ticket-textarea {
    width: 100%; min-height: 160px; background-color: #1e1e2d; border: 1px solid #2b3553;
    color: #fff; font-size: 14px; padding: 12px; border-radius: 5px; resize: vertical;
}
.ticket-textarea-sm {
    width: 100%; min-height: 90px; background-color: #1e1e2d; border: 1px solid #2b3553;
    color: #fff; font-size: 14px; padding: 10px; border-radius: 5px; resize: vertical;
}
.ticket-desc { color: #ddd; white-space: pre-wrap; background: #1e1e2d; padding: 12px; border-radius: 6px; }

.ticket-thread { max-height: 320px; overflow-y: auto; }
.ticket-msg { background: #1e1e2d; border-radius: 6px; padding: 10px 12px; margin-bottom: 10px; }
.ticket-msg-head { display: flex; justify-content: space-between; color: #e14eca; font-size: 13px; margin-bottom: 4px; }
.ticket-msg-time { color: #888; }
.ticket-msg-body { color: #eee; white-space: pre-wrap; }

.loader-container { display: flex; justify-content: center; align-items: center; height: 100vh; background-color: rgba(255,255,255,0.7); position: fixed; top: 0; left: 0; width: 100%; z-index: 9999; }
.loader { border: 8px solid #f3f3f3; border-top: 8px solid #3498db; border-radius: 50%; width: 50px; height: 50px; animation: spin 1s linear infinite; }
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
</style>